export default {
    "dayOfWeek": {
        "0": {
            "text": "Lunes",
            "textSmall": "Lun"
        },
        "1": {
            "text": "Martes",
            "textSmall": "Mar"
        },
        "2": {
            "text": "Miércoles",
            "textSmall": "Mié"
        },
        "3": {
            "text": "Jueves",
            "textSmall": "Jue"
        },
        "4": {
            "text": "Viernes",
            "textSmall": "Vie"
        },
        "5": {
            "text": "Sábado",
            "textSmall": "Sáb"
        },
        "6": {
            "text": "Domingo",
            "textSmall": "Dom"
        }
    },
    "month": {
        "1": {
            "text": "Enero",
            "textSmall": "Ene"
        },
        "2": {
            "text": "Febrero",
            "textSmall": "Feb"
        },
        "3": {
            "text": "Marzo",
            "textSmall": "Mar"
        },
        "4": {
            "text": "Abril",
            "textSmall": "Abr"
        },
        "5": {
            "text": "Mayo",
            "textSmall": "May"
        },
        "6": {
            "text": "Junio",
            "textSmall": "Jun"
        },
        "7": {
            "text": "Julio",
            "textSmall": "Jul"
        },
        "8": {
            "text": "Agosto",
            "textSmall": "Ago"
        },
        "9": {
            "text": "Septiembre",
            "textSmall": "Sep"
        },
        "10": {
            "text": "Octubre",
            "textSmall": "Oct"
        },
        "11": {
            "text": "Noviembre",
            "textSmall": "Nov"
        },
        "12": {
            "text": "Diciembre",
            "textSmall": "Dic"
        }
    }
};
